import { render, staticRenderFns } from "./successMessage.vue?vue&type=template&id=64001669&scoped=true&"
import script from "./successMessage.vue?vue&type=script&lang=js&"
export * from "./successMessage.vue?vue&type=script&lang=js&"
import style0 from "./successMessage.vue?vue&type=style&index=0&id=64001669&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64001669",
  null
  
)

export default component.exports